
import React from "react";
import { StartupAccount } from "@/types/startup";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface StartupSettingsProps {
  startupAccount: StartupAccount;
}

const StartupSettings: React.FC<StartupSettingsProps> = ({ startupAccount }) => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Settings</h2>
        <p className="text-muted-foreground">Manage your startup account settings</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Account Settings</CardTitle>
          <CardDescription>
            Settings panel will be available in the next update
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Here you'll be able to update your startup profile, manage notifications,
            and configure other account preferences.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default StartupSettings;
